import gql from 'graphql-tag';

export default gql`
  query BookingPathBackground {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        images(section: "stadiumPackageBookingPath") {
          id
          path
        }
      }
    }
  }
`;
